import { useParams } from 'react-router-dom';
import DefaultLayout from '../../layout/DefaultLayout';
import BreadcrumbTwo from '../../components/Breadcrumbs/BreadcrumbTwo';
import SectionWrapper from '../../components/SectionWrapper/SectionWrapper';
import PaymentForm from '../../modules/receivable/payments/components/PaymentForm';

const RegisterPaymentCxcPage = () => {
  const { receivableId } = useParams();

  const parsedReceivableId = receivableId ? Number(receivableId) : undefined;

  return (
    <DefaultLayout>
      <BreadcrumbTwo />

      <SectionWrapper>
        <PaymentForm
          key={parsedReceivableId}
          receivableId={parsedReceivableId}
        />
      </SectionWrapper>
    </DefaultLayout>
  );
};

export default RegisterPaymentCxcPage;
